import * as http from './http'
import Endpoints from '@ViewModels/ApiEndpoints'
import { ContactUsDto } from '@ViewModels/ContactUsDto'

const api = Endpoints.ContactUsApi

export const sendMessage = async (dto: ContactUsDto): Promise<CommitResult> => {
   const url = `${api}`
   return (await http.post(url, dto)) as CommitResult
}
